module.exports = __webpack_public_path__ + "img/check-on.a0f3474d.svg";